import { PriceCard } from '../types';

/**
 * Datos de precios de Conectemos Chile — sección "Nuestros Precios" de la landing.
 *
 * IMPORTANTE: estos valores son SOLO texto de marketing. No cobran nada — el
 * precio que se factura vive en las 3 tablas de código de `docs/PRECIOS.md` y en
 * los RPC de Supabase. Si cambia un precio, sincronizar TODOS los lugares de ese
 * archivo, no solo este.
 *
 * FUNC-131 (2026-10-06): el precio de las cards es el valor preferente presencial
 * (transferencia o efectivo); débito/crédito y online pagan el precio de lista.
 * Matriz completa en `src/lib/utils/pricing.ts`.
 *
 * Los dos "Plan Mensual" son promociones (septiembre 2026, extendidas a octubre) coordinadas por fuera
 * del sistema (el CTA manda a /agendar y el pack se cobra manual). No están
 * conectados al sistema de bonos. Retirar / revisar al cerrar la promo.
 */
export const pricing: PriceCard[] = [
  {
    id: 'individual',
    name: 'Terapia Individual',
    amount: '$32.000',
    cycle: 'Por sesión presencial · transferencia o efectivo',
    features: [
      'Sesión de 45-50 minutos',
      'Con débito o crédito (o sesión online): $36.000',
      'Atención personalizada',
      'Posibilidad de sesión online o presencial',
      'Seguimiento continuo del paciente',
      'Boleta reembolsable con Isapre y/o seguro complementario',
      'Horarios flexibles',
      'Evaluación inicial completa'
    ],
    bookingUrl: '/agendar'
  },
  {
    id: 'individual-mensual',
    name: 'Plan Mensual Individual',
    amount: '$100.000',
    cycle: '4 sesiones de 45 min al mes · promoción octubre',
    features: [
      'Cuatro sesiones semanales de 45 minutos',
      'Ahorro de $28.000 frente a 4 sesiones con transferencia ($44.000 frente a débito o crédito)',
      'Atención personalizada y seguimiento continuo',
      'Envío de material complementario',
      'Posibilidad de sesión online o presencial',
      'Flexibilidad para cambio de horarios',
      'Boleta reembolsable con Isapre y/o seguro complementario'
    ],
    bookingUrl: '/agendar'
  },
  {
    id: 'parejas',
    name: 'Terapia de Parejas',
    amount: '$36.000',
    cycle: 'Por sesión presencial · transferencia o efectivo',
    features: [
      'Sesión de 50 minutos (con débito o crédito u online: $38.750)',
      'Sesión extendida de 90 minutos por $41.000 (con débito o crédito u online: $46.000)',
      'Atención personalizada para ambos miembros',
      'Posibilidad de sesión online o presencial',
      'Seguimiento continuo de la pareja',
      'Herramientas de comunicación efectiva',
      'Material de apoyo personalizado',
      'Boleta reembolsable con Isapre y/o seguro complementario'
    ],
    bookingUrl: '/agendar'
  },
  {
    id: 'parejas-mensual',
    name: 'Plan Mensual Parejas',
    amount: '$159.000',
    cycle: '4 sesiones extendidas de 90 min al mes · promoción octubre',
    featured: true,
    features: [
      'Cuatro sesiones extendidas de 90 minutos',
      'Ahorro de $5.000 frente a 4 sesiones con transferencia ($25.000 frente a débito o crédito)',
      'Atención personalizada para ambos miembros',
      'Seguimiento continuo de la pareja',
      'Herramientas de comunicación efectiva',
      'Posibilidad de sesión online o presencial',
      'Flexibilidad para cambio de horarios',
      'Boleta reembolsable con Isapre y/o seguro complementario'
    ],
    bookingUrl: '/agendar'
  }
];
